var render = function render(_c, _vm) {
  return _c(
    "span",
    {
      staticClass:
        "badge badge-pill badge-primary p-2 px-2 mr-3 mb-3 mb-md-0 mb-sm-3",
      class: `border-color--${_vm.props.color} bg-tag-${_vm.props.type}`
    },
    [
      _c("em", { class: `${_vm.props.icon} color-${_vm.props.color}` }),
      _c(
        "span",
        {
          staticClass: "font-weight-bold ml-1",
          class: `color-${_vm.props.color}`
        },
        [_vm._v(" " + _vm._s(_vm.props.label) + " ")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }